<template>
    <div class="form">
        <Form ref="info"
            :label-width="80"
            :model="info"
            :rules="ruleValidate"
            :viewonly="isView">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="店面名称" prop="shopName">
                        <Input v-model="info.shopName"
                            placeholder>
                        </Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="门店电话" prop="tel">
                        <Input v-model="info.tel"
                            placeholder>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="详细地址" prop="addr">
                        <Input v-model="info.addr"
                            placeholder>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input v-model="info.remark" 
                            type="textarea"
                            :rows="4"
                            placeholder>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>

import {
    shopInfoView,
    shopInfoAdd,
    shopInfoUpdate
} from '@/api/shop'

export default {
    name: 'MShopForm',

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        actionType: {
            type: [String, Number],
            default: '',
        },
    },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: this.id,
                shopName: '',   // 店面名称
                tel: '',        // 店面电话
                addr: '',       // 店面地址
                lonlat: '',     // 店面定位
                remark: '',     // 备注
                ver: ''
            },
            isView: this.actionType === '2' ? true : false,
            dict: {
                invoiceType: this.$dict.NULL,
            }
        }
    },

    computed: {
        ruleValidate() {
            return this.isView ? {} :
                {
                    shopName: [
                        { required: true, message: '店面名称必填' }
                    ],
                    tel: [
                        { required: true, message: '店面电话必填' }
                    ]
                }
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return shopInfoView(this.id)
            } else {
                return Promise.resolve()
            }
        }
    },

    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        const btns = []
        if (this.actionType === '1' || this.actionType === '3') {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '取消',
            })
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        } else {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '关闭',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                this.fetch()
            ]).then((args) => {
                let [view] = args

                if (view) {
                    const viewData = view.data.entity
                    Object.keys(this.info).forEach(
                        (name) => (this.info[name] = viewData[name])
                    )
                }
            }).finally(() => {
                next()
            })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info.validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    if (this.id) {
                        return shopInfoUpdate(formData)
                    } else {
                        return shopInfoAdd(formData)
                    }
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="scss" scoped>

</style>